import { ECHARTS_LINE_COLOR } from '@/utils/echarts-option/line'

/**
 * 实时监控「告警趋势」折线与「风险类型分布」饼图共用系列色。
 * 修改时请与 `alert-trend-card.vue` 中折线 `SERIES_FIELDS` 同步。
 */
export const ALERT_TREND_SERIES_COLORS = {
  ransomware_risk: '#BD52D3', /* dm-keep：折线/饼图系列色（紫） */
  virus_risk: ECHARTS_LINE_COLOR.cyan,
  vulnerability_risk: ECHARTS_LINE_COLOR.primary,
  baseline_violation: '#E77E07', /* dm-keep：折线/饼图系列色（橙） */
  port_risk: ECHARTS_LINE_COLOR.danger,
} as const

/** `threat-distribution-card` 中 `mapRiskEventTrendLastDay` 的 type → 折线 field */
export const RISK_PIE_TYPE_TO_TREND_FIELD: Record<
  string,
  keyof typeof ALERT_TREND_SERIES_COLORS
> = {
  risk_ransomware: 'ransomware_risk',
  risk_virus: 'virus_risk',
  risk_leak: 'vulnerability_risk',
  risk_baseline: 'baseline_violation',
  risk_port: 'port_risk',
}

export function pieColorForRiskTrendType (pieType: string): string | undefined {
  const field = RISK_PIE_TYPE_TO_TREND_FIELD[pieType]
  return field ? ALERT_TREND_SERIES_COLORS[field] : undefined
}
